module.exports = __webpack_public_path__ + "static/media/signup_thanks.e26f9b12.png";